var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRank3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 53,
    viewBox: "0 0 34 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_148_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1241 23.6823L34.0001 49.3353L29.5082 47.0189L25.431 44.91L23.0123 48.7476L20.3172 53L13.4412 27.347L27.1241 23.6823Z",
    fill: "#BC7E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4615 24.6504L29.4391 47.0189L25.4655 44.8754L23.116 48.7476L17.1038 26.3444L23.4615 24.6504Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87602 23.6823L0 49.3353L4.49187 47.0189L8.56911 44.91L10.9878 48.7476L13.6829 53L20.5589 27.347L6.87602 23.6823Z",
    fill: "#BC7E0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5387 24.6504L4.56104 47.0189L8.53461 44.8754L10.8842 48.7476L16.8964 26.3444L10.5387 24.6504Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 31.0463C25.5683 31.0463 32.5143 24.0964 32.5143 15.5232C32.5143 6.94996 25.5683 0 17.0001 0C8.4318 0 1.48584 6.94996 1.48584 15.5232C1.48584 24.0964 8.4318 31.0463 17.0001 31.0463Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 28.3842C24.099 28.3842 29.8538 22.6261 29.8538 15.5232C29.8538 8.4202 24.099 2.66211 17.0001 2.66211C9.90126 2.66211 4.14648 8.4202 4.14648 15.5232C4.14648 22.6261 9.90126 28.3842 17.0001 28.3842Z",
    fill: "#FFD45C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 29.698C24.8242 29.698 31.1668 23.3517 31.1668 15.5231C31.1668 7.69461 24.8242 1.34833 17.0002 1.34833C9.17613 1.34833 2.8335 7.69461 2.8335 15.5231C2.8335 23.3517 9.17613 29.698 17.0002 29.698Z",
    stroke: "#9E520E",
    strokeWidth: 4.1261,
    strokeMiterlimit: 10,
    strokeDasharray: "0.73 0.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6545 25.6184L15.9635 25.5493L15.4106 24.2701L16.1017 24.3392L16.6545 25.6184Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6545 25.6184L15.9634 25.5493L15.1687 26.7247L15.8943 26.7939L16.6545 25.6184Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8577 25.4455L14.1667 25.2381L13.8557 23.8898L14.5468 24.0972L14.8577 25.4455Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8578 25.4455L14.1667 25.2381L13.1992 26.2062L13.8903 26.4136L14.8578 25.4455Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1644 24.8924L12.5425 24.5812L12.4734 23.2329L13.0953 23.5441L13.1644 24.8924Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1645 24.8924L12.5426 24.5812L11.4023 25.3418L12.0588 25.653L13.1645 24.8924Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5404 24.0626L10.9875 23.6478L11.1603 22.334L11.7132 22.7143L11.5404 24.0626Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5405 24.0626L10.9877 23.6478L9.77832 24.2009L10.3312 24.6158L11.5405 24.0626Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0895 22.9563L9.60571 22.4377L10.0203 21.1931L10.4695 21.6771L10.0895 22.9563Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0893 22.9563L9.6056 22.4377L8.32715 22.7834L8.81089 23.2675L10.0893 22.9563Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84566 21.608L8.46558 21.0548L9.08753 19.9139L9.43306 20.4671L8.84566 21.608Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84555 21.608L8.46547 21.0548L7.18701 21.1585L7.56709 21.7117L8.84555 21.608Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87823 20.0522L7.60181 19.4645L8.36197 18.4273L8.63839 19.015L7.87823 20.0522Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87812 20.0522L7.6017 19.4645L6.32324 19.3262L6.59967 19.9485L7.87812 20.0522Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15226 18.289L6.97949 17.6667L7.91242 16.8024L8.08518 17.4247L7.15226 18.289Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15238 18.289L6.97961 17.6667L5.77026 17.3555L5.94303 17.9778L7.15238 18.289Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73768 16.4566L6.70312 15.7998L7.73971 15.1429L7.77426 15.7652L6.73768 16.4566Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73778 16.4566L6.70323 15.7997L5.56299 15.2812L5.63209 15.9035L6.73778 16.4566Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6687 14.6589L6.73781 14.0365L7.8435 13.5871L7.77439 14.2094L6.6687 14.6589Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66878 14.6589L6.73789 14.0365L5.73585 13.3451L5.66675 13.9674L6.66878 14.6589Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9104 12.9994L7.04861 12.377L8.22341 12.135L8.05064 12.7228L6.9104 12.9994Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91045 12.9994L7.04866 12.377L6.2194 11.5473L6.04663 12.135L6.91045 12.9994Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42896 11.3744L7.70538 10.8213L8.88017 10.7521L8.60375 11.2707L7.42896 11.3744Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42885 11.3744L7.70527 10.8213L7.01422 9.85324L6.73779 10.4064L7.42885 11.3744Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25806 9.7841L8.60359 9.30008L9.74383 9.4038L9.3983 9.88782L8.25806 9.7841Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25804 9.78409L8.60357 9.30008L8.08527 8.26289L7.73975 8.74691L8.25804 9.78409Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32935 8.33205L9.74398 7.91718L10.8497 8.19376L10.435 8.6432L9.32935 8.33205Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32929 8.33205L9.74392 7.91718L9.43294 6.81085L9.01831 7.22572L9.32929 8.33205Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6768 7.05285L11.1605 6.70712L12.1625 7.22571L11.6788 7.53687L10.6768 7.05285Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6768 7.05285L11.1605 6.70713L11.0223 5.6008L10.5386 5.94653L10.6768 7.05285Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3008 6.05024L12.8191 5.80823L13.6829 6.46511L13.1646 6.70712L12.3008 6.05024Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3008 6.05024L12.8191 5.80823L12.8882 4.7019L12.3699 4.94391L12.3008 6.05024Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2012 5.3242L14.754 5.18591L15.4796 5.98109L14.9268 6.11938L14.2012 5.3242Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2012 5.32422L14.754 5.18592L15.0304 4.14874L14.4776 4.28703L14.2012 5.32422Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3457 25.6184L18.0368 25.5493L18.6242 24.2701L17.8985 24.3392L17.3457 25.6184Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3457 25.6184L18.0368 25.5493L18.8315 26.7247L18.1059 26.7939L17.3457 25.6184Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1423 25.4455L19.8334 25.2381L20.1444 23.8898L19.4533 24.0972L19.1423 25.4455Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1423 25.4455L19.8334 25.2381L20.8009 26.2062L20.1444 26.4136L19.1423 25.4455Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8354 24.8924L21.4574 24.5812L21.5265 23.2329L20.9046 23.5441L20.8354 24.8924Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8354 24.8924L21.4574 24.5812L22.5976 25.3418L21.9757 25.653L20.8354 24.8924Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4596 24.0626L23.0125 23.6478L22.8397 22.334L22.2869 22.7143L22.4596 24.0626Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4597 24.0626L23.0126 23.6478L24.2219 24.2009L23.6691 24.6158L22.4597 24.0626Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9108 22.9563L24.3946 22.4377L23.9799 21.1931L23.5308 21.6771L23.9108 22.9563Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9109 22.9563L24.3946 22.4377L25.6731 22.7834L25.1893 23.2675L23.9109 22.9563Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1545 21.608L25.5346 21.0548L24.9127 19.9139L24.5671 20.4671L25.1545 21.608Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1545 21.608L25.5346 21.0548L26.8131 21.1585L26.433 21.7117L25.1545 21.608Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1568 20.0522L26.3986 19.4645L25.6385 18.4273L25.3621 19.015L26.1568 20.0522Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1567 20.0522L26.3986 19.4645L27.6771 19.3262L27.4006 19.9485L26.1567 20.0522Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8478 18.289L27.0206 17.6667L26.0877 16.8024L25.9495 17.4247L26.8478 18.289Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8479 18.289L27.0207 17.6667L28.23 17.3555L28.0572 17.9778L26.8479 18.289Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2624 16.4566L27.297 15.7998L26.2604 15.1429L26.2258 15.7652L27.2624 16.4566Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2625 16.4566L27.297 15.7997L28.4372 15.2812L28.4027 15.9035L27.2625 16.4566Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3315 14.6589L27.2624 14.0365L26.1567 13.5871L26.2258 14.2094L27.3315 14.6589Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3316 14.6589L27.2625 14.0365L28.2645 13.3451L28.3336 13.9674L27.3316 14.6589Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1242 12.9994L26.9514 12.377L25.7766 12.135L25.9494 12.7228L27.1242 12.9994Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1242 12.9994L26.9514 12.377L27.7807 11.5473L27.9534 12.135L27.1242 12.9994Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5713 11.3744L26.3295 10.8213L25.1201 10.7521L25.3965 11.2707L26.5713 11.3744Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5712 11.3744L26.3293 10.8213L27.0204 9.85324L27.2623 10.4064L26.5712 11.3744Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7421 9.7841L25.4311 9.30008L24.2563 9.4038L24.6019 9.88782L25.7421 9.7841Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7421 9.78409L25.4312 9.30008L25.9149 8.26289L26.2604 8.74691L25.7421 9.78409Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.671 8.33205L24.2563 7.91718L23.1506 8.19376L23.5653 8.6432L24.671 8.33205Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.671 8.33205L24.2563 7.91718L24.5673 6.81085L24.982 7.22572L24.671 8.33205Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3234 7.05285L22.8742 6.70712L21.8376 7.22571L22.3214 7.53687L23.3234 7.05285Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3235 7.05285L22.8743 6.70713L22.9779 5.6008L23.4617 5.94653L23.3235 7.05285Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6993 6.05024L21.181 5.80823L20.3171 6.46511L20.8354 6.70712L21.6993 6.05024Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6992 6.05024L21.1809 5.80823L21.1118 4.7019L21.6301 4.94391L21.6992 6.05024Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.799 5.3242L19.2807 5.18591L18.5205 5.98109L19.0734 6.11938L19.799 5.3242Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.799 5.32422L19.2807 5.18592L18.9697 4.14874L19.5226 4.28703L19.799 5.32422Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0021 4.73648L17.0001 4.14874L15.998 4.73648L17.0001 5.28964L18.0021 4.73648Z",
    fill: "#D39816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0021 4.73648H15.998L17.0001 5.28964L18.0021 4.73648Z",
    fill: "#9E520E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5388 21.224C15.7174 21.224 14.9868 21.0747 14.3468 20.776C13.7068 20.4773 13.2054 20.0453 12.8428 19.48C12.4908 18.9147 12.3148 18.2427 12.3148 17.464V17.176H13.9948V17.432C13.9948 18.136 14.2241 18.696 14.6828 19.112C15.1521 19.5173 15.7708 19.72 16.5388 19.72C17.3068 19.72 17.9041 19.528 18.3308 19.144C18.7574 18.76 18.9708 18.2747 18.9708 17.688V17.544C18.9708 17.128 18.8694 16.792 18.6668 16.536C18.4641 16.28 18.1921 16.0933 17.8508 15.976C17.5094 15.848 17.1254 15.784 16.6988 15.784H14.6668V13.848L18.6028 11.528V11.304H12.5868V9.8H20.4268V12.072L16.6668 14.312V14.536H17.3548C17.9201 14.536 18.4534 14.6427 18.9548 14.856C19.4561 15.0693 19.8614 15.3947 20.1708 15.832C20.4908 16.2693 20.6508 16.824 20.6508 17.496V17.688C20.6508 18.4027 20.4801 19.0267 20.1388 19.56C19.7974 20.0827 19.3174 20.4933 18.6988 20.792C18.0801 21.08 17.3601 21.224 16.5388 21.224Z",
    fill: "#4B4B4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_148_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 53,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank3);
export default __webpack_public_path__ + "static/media/Rank3.c8bc7d37d1584504d0430f807bf2a5be.svg";
export { ForwardRef as ReactComponent };